import React, { useEffect } from 'react';
import gsap from 'gsap';
import './About.scss';

function About() {
  useEffect(() => {
    gsap.from('.about h1', {
      y: '-14vw',
      duration: 1,
    });
  }, []);

  return (
    <section className="about">
      <div className="box">
        <h1>
          About Me <hr />
        </h1>
      </div>
      <div>
        <p>
          I am a self taught developer, live in medan, Indonesia. Not so much
          great things happen in my life that i could share. But i just wanna
          told a simple story.
        </p>
        <br />
        <p>
          My old friend once asked me "Why'd you coding? isn't that hard?" I've
          been asked this question a few times now , and just answer them in a
          short sentence
        </p>
        <br />
        <p>
          "I Always admire programmer" , It is true, and i also wanna be admired
          by my ownself.
        </p>
        <br />
        <p>
          Even now, after i 'became a programmer' , i still and even more admire
          programmer.
        </p>
        <br />
        <p>Sound cheesy, but i really meant it.</p>
      </div>
    </section>
  );
}

export default About;
